import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Col, Row, theme } from "antd";
import { StickyRightColumn } from "./StickyRightColumn.js";
/**
 * Two-column shell. Layout lives in `.checkout-v2-card*`; only theme-driven
 * colours are inline so they track Antd tokens.
 *
 * `trustSignals` sits under the right column on desktop and is hidden on
 * mobile (the right column stacks above the form there, so extra trust
 * copy would push the CTA past the fold). The strongest claim —
 * Money-Back — goes in `right` directly under the total, so it reaches the
 * buyer before they commit.
 */ const TwoColumnLayout = ({ left, right, trustSignals })=>{
    const { token } = theme.useToken();
    return /*#__PURE__*/ _jsx("div", {
        className: "checkout-v2-card",
        style: {
            background: token.colorBgContainer
        },
        children: /*#__PURE__*/ _jsxs(Row, {
            gutter: 0,
            wrap: true,
            children: [
                /*#__PURE__*/ _jsx(Col, {
                    xs: {
                        span: 24,
                        order: 2
                    },
                    lg: {
                        span: 16,
                        order: 1
                    },
                    className: "checkout-v2-card__col--main",
                    children: left
                }),
                /*#__PURE__*/ _jsx(Col, {
                    xs: {
                        span: 24,
                        order: 1
                    },
                    lg: {
                        span: 8,
                        order: 2
                    },
                    className: "checkout-v2-card__col--summary",
                    style: {
                        background: token.colorBgLayout,
                        "--rc-checkout-v2-border-color": token.colorBorder
                    },
                    children: /*#__PURE__*/ _jsxs(StickyRightColumn, {
                        children: [
                            right,
                            trustSignals && /*#__PURE__*/ _jsx("div", {
                                className: "checkout-v2-trust-in-summary",
                                children: trustSignals
                            })
                        ]
                    })
                })
            ]
        })
    });
};
export { TwoColumnLayout };
